import React, {useEffect, useRef} from 'react';
import {easing} from 'maath';
import {useSnapshot} from 'valtio';
import {useFrame} from '@react-three/fiber';
import {Decal, useGLTF, useTexture} from '@react-three/drei';
import * as THREE from 'three';
import {fabric} from 'fabric';

import state from '../../../store';

interface ShirtProps {
    position: [number, number, number];
    tshirtAsset: string;
}

const Shirt: React.FC<ShirtProps> = ({position, tshirtAsset}) => {
    const snap = useSnapshot(state);
    const {nodes, materials} = useGLTF(tshirtAsset) as unknown as {
        nodes: any;
        materials: any;
    };

    const logoTexture = useTexture(snap.logoDecal) as THREE.Texture;
    const fullTexture = useTexture(snap.fullDecal) as THREE.Texture;

    useFrame((state, delta) => {
        easing.dampC(materials.lambert1.color, snap.color, 0.25, delta);
    });

    const stateString = JSON.stringify(snap);

    useEffect(() => {
        console.log(nodes);
        console.log(materials);
    }, [nodes, materials]);

    return (
        <group key={stateString} position={position}>
            <mesh
                castShadow
                geometry={nodes.T_Shirt_male.geometry}
                material={materials.lambert1}
                material-roughness={1}
                dispose={null}>
                {snap.isFullTexture && <Decal position={[0, 0, 0]} rotation={[0, 0, 0]} scale={1} map={fullTexture} />}
                {snap.isLogoTexture && (
                    <Decal
                        position={[0, 0.04, 0.15]}
                        rotation={[0, 0, 0]}
                        scale={0.15}
                        map={logoTexture}
                        {...{mapAnisotropy: 16, depthTest: false, depthWrite: true}}
                    />
                )}
            </mesh>
        </group>
    );
};

export default Shirt;
